<template>
  <div style="display: flex; align-items: center">
    <!-- <div
      v-popover="popoverRef"
      v-click-outside="onClickOutside"
      :style="'width:' + widthSpan"
      style="
        text-overflow: ellipsis;
        white-space: nowrap;
        display: inline-block;
        overflow: hidden;
        align-items: center;
      "
    >
      {{ text.replace(/\n/g, ',').substring(0, text.length) }}
    </div>
    <div>
      <el-popover
        placement="bottom-start"
        ref="popoverRef"
        virtual-triggering
        trigger="hover"
        popperClass="append-popover"
        persistent
        width="350"
        v-if="text && isPopover"
      >
        <div
          style="
            width: auto;
            min-height: 200px;
            font-size: 14px;
            padding: 15px;
            line-height: 28px;
            color: #333;
          "
        >
          <div v-for="text in text.split('\n')" :key="text">
            {{ text }}
          </div>
        </div>
      </el-popover>
    </div> -->
    <div
      :style="'width:' + widthSpan"
      style="
        text-overflow: ellipsis;
        white-space: nowrap;
        display: inline-block;
        overflow: hidden;
        align-items: center;
      "
    >
      <div
        v-for="(text1, index) in text.split('\n')"
        :key="text1"
        style="display: inline-block"
      >
        <el-popover
          placement="bottom-start"
          width="350"
          trigger="hover"
          v-if="isPopover"
        >
          <div>
            <div
              style="width: auto; font-size: 14px; padding: 5px; color: #333"
              v-for="text in text.split('\n')"
              :key="text"
            >
              {{ text }}
            </div>
          </div>
          <template #reference>
            <div>
              {{ text1
              }}<span v-if="index != text.split('\n').length - 1">,</span>
            </div>
          </template>
        </el-popover>
      </div>
    </div>
  </div>
</template>

<script setup>
import { nextTick, ref, unref } from 'vue';
import { ClickOutside as vClickOutside } from 'element-plus';

defineProps({
  text: {
    type: String,
    decription: '内容',
  },
  isPopover: {
    type: Boolean,
    default: true,
    description: '设置Popover显示',
  },
});

const popoverRef = ref();
//浏览器宽度的80%,Append宽度设置
const widthSpan = window.innerWidth * 0.8 + 'px';
const onClickOutside = () => {
  if (popoverRef.value) {
    unref(popoverRef).popoverRef?.delayHide?.();
  }
};
</script>
<style>
.append-popover {
  width: auto;
  min-width: 250px !important;
  border-radius: 12px;
}
</style>
